import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IAssets } from '../types';
import { AssetsRow } from './assets-row';

interface Props {
  tableProps: TableProps;
  rows?: IAssets[];
  loading: boolean;
  canAddAsset: string;
}

const AssetsList = ({ tableProps, rows, loading, canAddAsset }: Props) => {
  const TABLE_HEAD = [
    { id: 'assetsId', label: 'Assets Id', align: 'center' },
    { id: 'assetUser', label: 'Assets User', align: 'center', sortable: false },
    { id: 'assetName', label: 'Assets Name', align: 'center' },
    { id: 'purchase', label: 'Purchase Date', align: 'center', sortable: false },
    { id: 'warranty', label: 'Warranty', align: 'center', sortable: false },
    { id: 'warranty end', label: 'Warranty End', align: 'center', sortable: false },
    { id: 'amount', label: 'Amount', align: 'center', sortable: false },
    { id: 'status', label: 'Status', align: 'center', sortable: false },
    ...(canAddAsset ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }] : []),
  ];
  return (
    <PaginatedTable<IAssets>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <AssetsRow
          row={row}
          canAddAsset={canAddAsset}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};
export default AssetsList;
